import { Tab, TabProps } from 'react-admin';
import EmptyState from './EmptyState';
import ErrorState from './ErrorState';
import Header from './Header';
import LoadingState from './LoadingState';
import OrderALaCarteButton from './OrderALaCarteButton';
import QuickActions from './QuickActions';
import ReportAtAGlance from './ReportAtAGlance';
import ReportSelector from './ReportSelector';
import StatusAlert from './StatusAlert';
import Timeline from './Timeline';
import AuditSection from './AuditSection';
import WebhookEvents from './WebhookEvents';
import StatusHistory from './StatusHistory';
import { TabBody } from './styled';
import useController from './useController';

const DrugTestTab = (props: Partial<TabProps>) => {
  const {
    loading,
    error,
    reports,
    selectedReport,
    selectedReportId,
    selectReport,
    webhookEvents,
    history,
    secondaryLoading,
    refetch,
  } = useController();

  return (
    <Tab label="Drug Test Reports" {...props}>
      <TabBody>
        <Header actions={<OrderALaCarteButton />} />
        {loading ? (
          <LoadingState />
        ) : error ? (
          <ErrorState message={error} onRetry={refetch} />
        ) : reports.length === 0 ? (
          <EmptyState />
        ) : (
          <>
            <ReportSelector reports={reports} selectedReportId={selectedReportId} onSelect={selectReport} />
            <QuickActions report={selectedReport} />
            <StatusAlert report={selectedReport} />
            <ReportAtAGlance report={selectedReport} />
            <Timeline report={selectedReport} />
            <AuditSection>
              <WebhookEvents events={webhookEvents} loading={secondaryLoading} />
              <StatusHistory history={history} report={selectedReport} loading={secondaryLoading} />
            </AuditSection>
          </>
        )}
      </TabBody>
    </Tab>
  );
};

export default DrugTestTab;
